import api from "../api"
import { TYPE_FETCHING } from "../constants"

export const getShowOtherIndicatorApi = (id) => {
  return api(`companies/surveytypes/${id}`, TYPE_FETCHING.get)
}

export const setUpdateOtherIndicatorApi = (payload) => {
  const { id, params } = payload
  return api(`companies/surveytypes/${id}`, TYPE_FETCHING.put, params)
}
